import { TransactionOrder } from "creso-core/types";
import {
  convertToCurrency,
  formatAsPercentage,
  isSIPOrder,
} from "creso-core/utils";
import { ArrowUpWideNarrow } from "lucide-react";

export function OrderAdditionalInfo({ order }: { order: TransactionOrder }) {
  if (
    isSIPOrder(order) &&
    order.action_type !== "MODIFY" &&
    order.step_up_frequency
  ) {
    return (
      <span className="text-muted-foreground flex items-center text-xs gap-1">
        <ArrowUpWideNarrow className="size-4" />
        Step up by{" "}
        {order.step_up_amount
          ? convertToCurrency(order.step_up_amount ?? "")
          : formatAsPercentage(order.step_up_percentage, "-", 1)}{" "}
        every {order.step_up_frequency} months
      </span>
    );
  }

  return null;
}
